module.exports = __webpack_public_path__ + "static/media/freedomlyTwitter-600x314.e597293a.jpg";